"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedXDAIERC20 = void 0;
// List of the supported bsc network tokens
exports.supportedXDAIERC20 = {
    '0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83': {
        name: 'USDC token on xDai',
        symbol: 'USDC',
        decimals: 6,
    },
};
